import type { Reader } from '@/api/client';
import {
  READERS_CATALOG_FILTERS_ENABLED_KEY,
  READERS_CATALOG_FILTERS_KEY,
  normalizeMultiPersonRule,
  readersCatalogRowMatchesRule,
  type FilterRule,
  type TableFiltersContextValue,
} from '@/lib/tableFilters';
import { sanitizeReaderTagsFacetRule } from '@/hooks/usePersistedColumnFilters';
import {
  useEntityTableFilters,
  type UseEntityTableFiltersReturn,
} from '@/hooks/useEntityTableFilters';

function normalizeReadersCatalogRuleOnLoad(_columnId: string, rule: FilterRule): FilterRule {
  if (rule.type === 'readerTagsFacet') {
    return sanitizeReaderTagsFacetRule(rule as Extract<FilterRule, { type: 'readerTagsFacet' }>);
  }
  return normalizeMultiPersonRule(rule);
}

export interface ReadersCatalogTableFiltersContextValue extends TableFiltersContextValue<Reader> {
  filterReaders: (readers: Reader[]) => Reader[];
}

export interface UseReadersCatalogTableFiltersReturn
  extends UseEntityTableFiltersReturn<Reader>,
    ReadersCatalogTableFiltersContextValue {}

export function useReadersCatalogTableFilters(): UseReadersCatalogTableFiltersReturn {
  const entityFilters = useEntityTableFilters<Reader>({
    enabledKey: READERS_CATALOG_FILTERS_ENABLED_KEY,
    filtersKey: READERS_CATALOG_FILTERS_KEY,
    normalizeLoadedRule: normalizeReadersCatalogRuleOnLoad,
    matchesRule: readersCatalogRowMatchesRule,
  });

  return {
    ...entityFilters,
    filterReaders: entityFilters.filterItems,
  };
}
